export const PlatformBridge = {
  get isDev(): boolean {
    return import.meta.env.DEV;
  },
  get isCapacitor(): boolean {
    if (typeof window === 'undefined') return false;
    const w = window as unknown as { Capacitor?: unknown };
    return typeof w.Capacitor !== 'undefined' && Boolean(w.Capacitor);
  },
  get platform(): string {
    if (typeof window === 'undefined') return 'web';
    const w = window as unknown as { Capacitor?: { getPlatform?: () => string } };
    return w.Capacitor?.getPlatform?.() ?? 'web';
  },
  get capacitorPlugins() {
    if (typeof window === 'undefined') return null;
    const w = window as unknown as { Capacitor?: { Plugins?: Record<string, unknown> } };
    return w.Capacitor?.Plugins || null;
  },
};
